export class UpvStatusConverterValueConverter {

  toView(value: number): string {
    switch (value) {
      case -4:
        return 'Removed';
      case -3:
        return 'Proc Error';
      case -2:
        return 'Prep Error';
      case -1:
        return 'Parse Error';
      case 0:
        return 'New';
      case 1:
        return 'Edited';
      case 2:
        return 'Queued For Parsing';
      case 3:
        return 'Parsed';
      case 4:
        return 'Queued For Processing';
      case 5:
        return 'Processed';
      case 6:
        return 'Reopened';
      case 8:
        return 'Being processed';
    }
  }
}

